var _rect, _path, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#417EB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4L12.75 4ZM11.4697 15.7303C11.7626 16.0232 12.2374 16.0232 12.5303 15.7303L17.3033 10.9574C17.5962 10.6645 17.5962 10.1896 17.3033 9.8967C17.0104 9.60381 16.5355 9.60381 16.2426 9.8967L12 14.1393L7.75736 9.8967C7.46447 9.60381 6.98959 9.60381 6.6967 9.8967C6.40381 10.1896 6.40381 10.6645 6.6967 10.9574L11.4697 15.7303ZM11.25 4L11.25 15.2L12.75 15.2L12.75 4L11.25 4Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.75,
    y1: 18.45,
    x2: 19.25,
    y2: 18.45,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDownload);
export default __webpack_public_path__ + "static/media/icn_download.9f92a04d.svg";
export { ForwardRef as ReactComponent };